export default {
  title: {
    id: 'review_ai_summary_title',
    defaultMessage: 'What customers are saying',
  },
  caption: {
    id: 'review_ai_summary_caption',
    defaultMessage: 'AI generated',
  },
  tooltip: {
    id: 'review_ai_summary_tooltip',
    defaultMessage:
      'Summary created by AI from recent customer feedback over 6 months, last updated on {updateDate}',
  },
  tooltipLatestReviews: {
    id: 'review_ai_summary_tooltip_latest_reviews',
    defaultMessage:
      'AI summary from latest {number} reviews, updated on {updateDate}.',
  },
  tooltipAllReviews: {
    id: 'review_ai_summary_tooltip_all_reviews',
    defaultMessage: 'AI summary from all reviews, updated on {updateDate}.',
  },
} as const
